import { shouldArmBarrierForListTopReturn } from './barrierPolicy';

// Decisoes do scroll natural da lista (sem acoplamento com Vue/DOM).
// O snap final em si fica em `resolveDirectionalSnap` (mesma regra do drag).

export interface UpdateListScrollInteractionInput {
	previousY: number;
	y: number;
	isUserScroll: boolean;
	isScreenBelowBreakpoint: boolean;
	isAnimating: boolean;
	maxOffset: number;
	restingPx: number;
	buffer: number;
	supportsScrollEnd: boolean;
}

export interface UpdateListScrollInteractionResult {
	shouldArmBarrier: boolean;
	shouldScheduleScrollEnd: boolean;
}

export type FinishListScrollAction = 'ignore' | 'snap';

export interface FinishListScrollInteractionInput {
	y: number;
	maxOffset: number;
	restingPx: number;
	isScreenBelowBreakpoint: boolean;
	isAnimating: boolean;
	isDragging: boolean;
}

// Durante o scroll: decide se a barreira fisica deve armar (retorno da leitura
// para a faixa do drawer) e se precisamos agendar o fim do scroll por timer.
export function updateListScrollInteraction({
	previousY,
	y,
	isUserScroll,
	isScreenBelowBreakpoint,
	isAnimating,
	maxOffset,
	restingPx,
	buffer,
	supportsScrollEnd
}: UpdateListScrollInteractionInput): UpdateListScrollInteractionResult {
	if (isAnimating || !isScreenBelowBreakpoint || !isUserScroll) {
		return { shouldArmBarrier: false, shouldScheduleScrollEnd: false };
	}

	const shouldArmBarrier = shouldArmBarrierForListTopReturn({
		previousY,
		y,
		maxOffset,
		buffer
	});

	const shouldScheduleScrollEnd =
		!shouldArmBarrier && !supportsScrollEnd && y <= maxOffset + restingPx;

	return { shouldArmBarrier, shouldScheduleScrollEnd };
}

// Ao fim do scroll: 'ignore' quando estamos em leitura, animando, arrastando ou
// no desktop; senao 'snap' (o orquestrador escolhe o alvo via direcao do gesto).
export function finishListScrollInteraction({
	y,
	maxOffset,
	restingPx,
	isScreenBelowBreakpoint,
	isAnimating,
	isDragging
}: FinishListScrollInteractionInput): FinishListScrollAction {
	if (
		isAnimating ||
		!isScreenBelowBreakpoint ||
		isDragging ||
		y > maxOffset + restingPx
	) {
		return 'ignore';
	}

	return 'snap';
}
